module.exports = __webpack_public_path__ + "static/koncese-305bcd8d0247872671c72bb298e26da8.svg";